<div class="narrow-content">
  <h1>Access Denied</h1>
  <p>You don't have authorization to view the page you are trying to access.</p>
  <p>
    Go back to the
    <a routerLink="/" class="text-link">home page.</a>
  </p>
</div>
